import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { ApplicationDto, Application } from '../../models';

export interface LimitedInfo {
    name: string;
    guid: string;
    shortComment: string;
    creationDate: string;
    creationUser: string;
    lastModificationstring: Date;
    lastModifier: string;
}

export interface ChildApplicationComparison {
    parentInfo: LimitedInfo;
    childInfo: LimitedInfo;
    isOutOfDate: boolean;
    canUpdate: boolean;
    message?: string;
}

export interface IchildApplicationService {
    createChildApplicationFromGroup(newApplication: Application, groupGuid: string, includeChildren: boolean): angular.IPromise<ApplicationDto>;
    compare(): angular.IPromise<ChildApplicationComparison[]>;
    updateChildrenApplications(results: ChildApplicationComparison[]): angular.IPromise<ChildApplicationComparison[]>;
}

export class ChildApplicationService implements IchildApplicationService {


    static serviceId = 'childApplicationService';
    static $inject = ['requestService'];

    private _controllerUrl = 'childApplication';

    constructor(private _requestService: IRequestService) {
    }

    createChildApplicationFromGroup(newApplication: Application, groupGuid: string, includeChildren: boolean): angular.IPromise<ApplicationDto> {
        const url = `${this._controllerUrl}/createChild`;
        const data = {
            newApplication: newApplication,
            groupGuid: groupGuid,
            includeChildren: includeChildren
        };
        return this._requestService.postAtV1(url, data);
    }

    compare(): angular.IPromise<ChildApplicationComparison[]> {
        const url = `${this._controllerUrl}/compare`;
        this._requestService.cleanCacheAtV1(url);
        return this._requestService.getAtV1(url);
    }

    updateChildrenApplications(results: ChildApplicationComparison[]): angular.IPromise<ChildApplicationComparison[]> {
        const url = `${this._controllerUrl}/update`;
        return this._requestService.postAtV1(url, results);
    }
}